
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.323.823a.25.25 0 01.354 0l3 3a.25.25 0 010 .354l-3 3a.25.25 0 01-.354-.354L5.146 4 2.323 1.177a.25.25 0 010-.354z","fill":"#425466"}})])
          )
        }
      }
    